import { UploadIniFileCommandResponse } from '../generated';
import { client } from '../generated/client.gen';

export const postIniFile = async (
  modelId: string,
  formData: FormData,
): Promise<UploadIniFileCommandResponse> => {
  const response = await client.instance
    .post(`/api/v1/uploads/models/${modelId}/ini-file`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .catch(function (err) {
      return Promise.reject(err);
    });

  return response.data;
};
